// AbsolutePink design tokens — see .claude/DESIGN.md.
// Color values are CSS custom properties from `src/styles/tokens.css`, so
// inline styles like `style={{ background: T.bg }}` automatically react to
// `prefers-color-scheme` and `[data-theme]` overrides.
export const T = {
  // Core
  bg: 'var(--ap-parchment)',
  surface: 'var(--ap-card)',
  card: 'var(--ap-card)',
  cardAlt: 'var(--ap-pink-wash)',
  border: 'var(--ap-rule)',
  borderLight: 'var(--ap-rule)',

  // Text
  text: 'var(--ap-ink)',
  textMuted: 'var(--ap-muted)',

  // Brand
  accent: 'var(--ap-pink)',
  accentDark: 'var(--ap-pink-dark)',
  onAccent: 'var(--ap-on-accent)',

  // Status — functional only
  red: 'var(--ap-alert)',
  orange: 'var(--ap-caution)',
  green: 'var(--ap-good)',
} as const;

export type Token = keyof typeof T;

// Spacing scale — 8px base unit, matches DESIGN.md and tokens.css --space-*
// Mapping from old off-scale ladder (commit ref: pre-eames-fixes):
//   old xs=4   → xs=4   (exact)
//   old sm=6   → sm=8   (tie rounds up)
//   old md=8   → sm=8   (exact match)
//   old lg=10  → sm=8   (nearest)
//   old xl=12  → md=16  (tie rounds up)
//   old xxl=16 → md=16  (exact)
//   old xxxl=20→ lg=24  (tie rounds up)
export const SPACE = {
  '2xs': 2,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32,
  '2xl': 48,
  '3xl': 64,
} as const;

export type Space = keyof typeof SPACE;

export const RADIUS = {
  sm: 2,
  md: 4,
  lg: 8,
  pill: 999,
} as const;

export const SHADOW = {
  none: 'none',
  card: '0 1px 0 rgba(0, 0, 0, 0.08)',
} as const;

export const TRANSITION = {
  fast: '150ms ease',
  base: '200ms ease',
  slow: '300ms ease',
} as const;
